var map = {
	"./andrz.jpg": "e3a2",
	"./basket.png": "34a0",
	"./border-vert.png": "7aba",
	"./border.jpg": "0783",
	"./border.png": "b786",
	"./clip-shadow-people-dancing.jpg": "186b",
	"./color-back.bmp": "3da8",
	"./depeche.jpg": "752e",
	"./dyskoteka.jpg": "95dc",
	"./football.png": "2345",
	"./hallo.jpg": "251d",
	"./legia-napoli.jpg": "be87",
	"./logo.png": "73d7",
	"./people_dance.png": "25d6",
	"./rugby.png": "7ef7",
	"./sports.jpg": "b884",
	"./tennis.png": "e2a8",
	"./transparent_logo.png": "089b",
	"./transparent_logo_icon.png": "3a2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf0c";